import { TFileType } from '../types/file';

export const MIME_TYPES: Record<TFileType, string> = {
  xml: 'application/xml',
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
